import IndicatorScreen from 'components/indicator/IndicatorScreen';
import { useApiState } from 'hooks/useApiState';
import { useAppState } from 'hooks/useAppState';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ProxyCallback() {
  const navigate = useNavigate();
  const { initializeAcctStateByProxy } = useAppState();
  const { postProxyLogin } = useApiState();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const { valid, companyCd } = await postProxyLogin({});
        if (valid && companyCd) {
          await initializeAcctStateByProxy(companyCd);
          navigate(`/ws/${companyCd}`);
        } else {
          navigate('/error');
        }
      } catch (e: unknown) {
        console.debug('ProxyCallback エラー', e);
        navigate('/login');
      }
    };
    checkSession();
  }, [navigate, initializeAcctStateByProxy, postProxyLogin]);

  return <IndicatorScreen visible={true} />;
}
